import moment from 'moment'

export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY'

export const getMask = () => DEFAULT_DATE_FORMAT.replace(/[^\d/-/.-]/g, '9')

export const dateMaskConfig = {
  mask: getMask(),
  maskChar: null
}

export const formatDateToString = (date: string) => {
  return moment(date).format(DEFAULT_DATE_FORMAT)
}

export const formatDateFromString = (date: string) => {
  console.log('date', moment(date, DEFAULT_DATE_FORMAT).toISOString())
  return moment(date, DEFAULT_DATE_FORMAT).toISOString()
}
